import { getJson } from "./client";

export interface WalletBalance {
	symbol: string;
	/** `null` for the native asset (ETH). */
	address: string | null;
	decimals: number;
	rawBalance: string;
	error?: string;
}

export interface WalletBalancesResponse {
	wallet: string;
	asOf: string;
	balances: WalletBalance[];
}

export function fetchWalletBalances(): Promise<WalletBalancesResponse> {
	return getJson<WalletBalancesResponse>("/info/balances");
}
